import React from "react";
import Modal from "react-modal";

// Guarded: this runs at import time and throws outright if #root isn't
// mounted yet (or at all, as in tests).
if (typeof document !== "undefined" && document.getElementById("root")) {
  Modal.setAppElement("#root");
}

const PlayerControlsModal = ({
  isOpen,
  onRequestClose,
  onKick,
  onSetTeam,
  player,
  modalStyle,
  amILeader,
  isCompact,
  teams = [],
  currentTeamIndex = -1,
  otherTeamIndex = 0,
}) => {
  const leader = amILeader();
  const isSpectator = currentTeamIndex === -1;
  const otherTeamName = teams[otherTeamIndex]?.name || "the other team";

  // On a phone a popover pinned to the tap coordinates lands under a thumb and
  // can run off the edge, so it becomes a bottom sheet instead.
  const content = isCompact
    ? {
        top: "auto",
        left: 0,
        right: 0,
        bottom: 0,
        transform: "none",
        width: "auto",
        boxSizing: "border-box",
        borderRadius: "12px 12px 0 0",
        padding: "16px 16px calc(16px + env(safe-area-inset-bottom))",
      }
    : {
        ...modalStyle,
        width: "250px",
        boxSizing: "border-box",
        padding: "8px",
        borderRadius: "6px",
      };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      closeTimeoutMS={120}
      style={{
        overlay: {
          backgroundColor: isCompact ? "rgba(0, 0, 0, 0.45)" : "transparent",
          zIndex: 40,
        },
        content: {
          ...content,
          color: "#fff",
          background: "var(--secondary-color)",
          border: "1px solid rgba(255, 255, 255, 0.14)",
          boxShadow: "0 2px 6px rgba(0,0,0,.3), 0 18px 40px rgba(0,0,0,.4)",
        },
      }}
      contentLabel={`Controls for ${player.username}`}
    >
      <h3 className="modal-title">{player.username}</h3>

      {!leader && (
        <p className="modal-note">Only the lobby leader can move or kick.</p>
      )}

      <div className="modal-actions">
        <button
          type="button"
          className="modal-action"
          disabled={!leader}
          onClick={() => onSetTeam(player.id, otherTeamIndex)}
        >
          {isSpectator ? `Put on ${otherTeamName}` : `Move to ${otherTeamName}`}
        </button>

        {!isSpectator && (
          <button
            type="button"
            className="modal-action"
            disabled={!leader}
            onClick={() => onSetTeam(player.id, null)}
          >
            Make a spectator
          </button>
        )}

        <button
          type="button"
          className="modal-action modal-action--danger"
          disabled={!leader}
          onClick={() => onKick(player)}
        >
          Kick from lobby
        </button>

        <button
          type="button"
          className="modal-action modal-action--quiet"
          onClick={onRequestClose}
        >
          Cancel
        </button>
      </div>
    </Modal>
  );
};

export default PlayerControlsModal;
